import $ from "jquery";

import * as channel from "./channel.ts";
import * as ui_util from "./ui_util.ts";

let overlay_visible = false;
let current_message_id: number | null = null;

function add_thumbs_up_reaction(): void {
    if (current_message_id === null) {
        return;
    }
    
    // Use the dedicated popHTML acknowledgment endpoint
    // This bypasses normal message access checks since the user
    // was explicitly sent the popup event
    void channel.post({
        url: "/json/messages/" + current_message_id + "/pophtml_ack",
        data: {},
        // Silently ignore errors - the reaction is just a convenience acknowledgment
        error() {},
    });
}

export function show_pop_html(html: string, message_id: number): void {
    current_message_id = message_id;
    
    // Create overlay if it doesn't exist
    let $overlay = $("#pop-html-overlay");
    if ($overlay.length === 0) {
        $overlay = $(`
            <div id="pop-html-overlay" class="pop-html-overlay">
                <div class="pop-html-backdrop"></div>
                <div class="pop-html-content">
                    <button class="pop-html-close" aria-label="Close">&times;</button>
                    <div class="pop-html-body"></div>
                </div>
            </div>
        `);
        $("body").append($overlay);

        // Close button handler
        $overlay.find(".pop-html-close").on("click", () => {
            hide_pop_html();
        });

        // Backdrop click handler
        $overlay.find(".pop-html-backdrop").on("click", () => {
            hide_pop_html();
        });

        // ESC key handler
        $(document).on("keydown.pop-html", (e) => {
            if (e.key === "Escape" && overlay_visible) {
                hide_pop_html();
            }
        });
    }

    // Parse and inject HTML
    const $body = $overlay.find(".pop-html-body");
    $body.empty();
    const parsed_html = ui_util.parse_html(html);
    $body.append(parsed_html);

    // Show overlay
    $overlay.addClass("show");
    overlay_visible = true;

    // Set focus to close button for keyboard accessibility
    $overlay.find(".pop-html-close").trigger("focus");
}

export function hide_pop_html(): void {
    const $overlay = $("#pop-html-overlay");
    if ($overlay.length > 0) {
        $overlay.removeClass("show");
        overlay_visible = false;
        
        // Add thumbs up reaction when popup is closed to acknowledge it was read
        add_thumbs_up_reaction();
        current_message_id = null;
    }
}
